module.exports = __webpack_public_path__ + "img/techcast-grafik_event-plattform.bcdfa1b.png";